import React from "react";
import { Link } from "react-router-dom";

const HelpCenter = () => {
  return (
    <div className="min-h-screen bg-gray-50 px-4 py-10">
      <div className="max-w-3xl mx-auto bg-white rounded-xl shadow-sm border border-gray-200 p-6">
        <div className="flex items-center justify-between mb-4">
          <h1 className="text-2xl font-bold text-gray-900">Help Center</h1>
          <Link to="/" className="text-sm text-indigo-600 hover:text-indigo-700">
            Back to Home
          </Link>
        </div>
        <p className="text-sm text-gray-600 leading-relaxed">
          Find answers to common questions about accounts, messaging, and privacy.
        </p>
        <ul className="mt-4 space-y-3 text-sm text-gray-600 list-disc list-inside">
          <li>How to reset your password</li>
          <li>How to update your profile</li>
          <li>How to report a user</li>
          <li>How to manage notifications</li>
        </ul>
      </div>
    </div>
  );
};

export default HelpCenter;
